import React from 'react';

import { useLocalize } from '../../../hooks/useLocalize';
import { ListModal } from '../../listModal/ListModal';
import { SearchCurrencyItem } from '../searchCurrencyItem/SearchCurrencyItem';
import { ICurrency } from '../utils';

interface CurrencyModalMobileProps {
  modalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  preferredCurrencyCode: string;
  suggestedCurrencies: ICurrency[];
  otherCurrencies: ICurrency[];
  onItemSelected: (preferredCurrencyCode: string) => Promise<void>;
}

export const CurrencyModalMobile: React.FC<CurrencyModalMobileProps> = ({
  modalOpen, setModalOpen, suggestedCurrencies, preferredCurrencyCode, onItemSelected, otherCurrencies,
}) => {
  const { translate: t } = useLocalize();

  return (
    <ListModal
      show={modalOpen}
      modalTitle={t('select_your_currency')}
      onClose={() => setModalOpen(false)}
    >
      <div>
        <div className="modal-list-header">{t('suggested_currencies')}</div>
        {suggestedCurrencies.map((currencyItem) => (
          <SearchCurrencyItem
            key={currencyItem.key}
            currency={currencyItem.value}
            isSelectedItem={preferredCurrencyCode === currencyItem.key}
            code={currencyItem.key}
            onClick={() => {
              onItemSelected(currencyItem.key);
              setModalOpen(false);
            }} />
        ))}
        <div className="modal-list-header mt-2">{t('all_currencies')}</div>
        {otherCurrencies.map((currencyItem: any) => (
          <SearchCurrencyItem
            key={currencyItem.key}
            currency={currencyItem.value}
            isSelectedItem={preferredCurrencyCode === currencyItem.key}
            code={currencyItem.key}
            onClick={() => {
              onItemSelected(currencyItem.key);
              setModalOpen(false);
            }} />
        ))}
      </div>
    </ListModal>
  );
};
